import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";

import { openModal } from 'reducers/modalReducer';
import { MODAL_TYPES } from 'view/ModalManager';

// import { useMediaPredicate } from 'react-media-hook';
// import { MOBILE_SIZE } from 'utils/mediaQueryUtils';

import Spinner from 'components/Spinner';
import NothingFoundCardContent from 'components/NothingFoundCardContent';
import ComplianceDatesChecklist from 'components/complianceCalendar/ComplianceDatesChecklist';
import MonthCalendar from 'components/complianceCalendar/MonthCalendar';
import { concatAllComplianceDates } from 'utils/complianceDatesUtils';

import './ComplianceDates.css';


function ComplianceDates(props) {
	// const isMobile = useMediaPredicate(MOBILE_SIZE);
	const dispatch = useDispatch();
	const {
		propertyId,
		isLoading,
		isLoadingProperty,
		complianceData,
		address,
	} = useSelector(state => ({
		propertyId: state.property.propertyData?.id,
		isLoading: state.complianceDatesPortfolio.isLoading || state.property.isLoading,
		isLoadingProperty: state.property.isLoading,
		complianceData: state.complianceDatesPortfolio.data || {},
		address: state.property.propertyData?.address,
	}));

	let nothingFoundText = null;
	let events = concatAllComplianceDates(complianceData);

	const onEventClick = (e) => {
		return dispatch(openModal(MODAL_TYPES.CALENDAR_EVENT, { 
			eventTitle: e.event.title,
		}));
	}

	return (
		<div className="rd-compliance-dates">
			<div className="rd-compliance-dates-header building-info-card-header">
				<h2 className="rd-compliance-dates-title building-info-card-title">Compliance</h2>
				<Link
					className="rd-compliance-calendar-link"
					to={`/property/${address}/calendar`}
					title="Open full calendar"
					aria-label="Open full calendar"
				>
					<i className="bi bi-calendar3" />
				</Link>
			</div>
			{isLoadingProperty && <Spinner />}
			{!isLoading && !events?.length && (
				<div className="rd-compliance-empty">
					<NothingFoundCardContent text={nothingFoundText || 'No compliance events for this property'} />
				</div>
			)}
			{!isLoadingProperty && (
				<div className="d-flex compliance-dates-content">
					<div className="calendar-wrapper">
						<MonthCalendar height={405} propertyId={propertyId} onEventClick={onEventClick} eventColor='#161616' />
					</div>
					<div className="dates-list-wrapper">
						<h3>Compliance Dates</h3>
						<ComplianceDatesChecklist propertyId={propertyId} />
					</div>
				</div>
			)}
		</div>
	);
}

export default ComplianceDates;
